import {
  hipFlexorPNG,
  hipFlexorWEBP,
} from '~/pages/anatomyV2/hipFlexor/constants'
import TrueFalseQuestionTemplate from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 2

const HipFlexorAnatomyV2 = (props: TPageProps) => (
  <TrueFalseQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.hipFlexor.title"
    factI18nKey="onboarding.hipFlexor.fact"
    questionImagePNG={hipFlexorPNG}
    questionImageWEBP={hipFlexorWEBP}
    questionImageAlt="Hip flexor muscles"
    question="Spot the fake: hip flexor tightness"
  />
)

export default HipFlexorAnatomyV2
